import React from 'react';
import { Notes, Note } from '@tviklax/ui-components';

// Map AddNotePayload to Note type
export type SavedNote = Note;

export interface SchedulingNotesProps {
  notes: SavedNote[];
  isLoading?: boolean;
  actions?: React.ReactNode;
}

export const SchedulingNotes: React.FC<SchedulingNotesProps> = ({ notes, isLoading = false, actions }) => {
  return (
    <Notes 
      notes={notes} 
      isLoading={isLoading}
      title="Notes"
      emptyMessage="No notes yet. Add a note to track changes, risks, and milestones."
      actions={actions}
    />
  );
};
